export interface IPagingOptions {
    pageNumber: number;
    pageSize: number;
}

export class PagingOptions implements IPagingOptions {
    pageNumber = 1;
    pageSize = 25;
}